import Layout from "@/components/Layout";
import CardsView from "@/components/CardsView";
import { SeeItInAction } from "@/components/SeeItInAction";
import { IdCard, Layers } from "lucide-react";
import { useSearchParams } from "react-router-dom";

export default function CardsPage() {
  const [searchParams] = useSearchParams();
  const portfolio = searchParams.get("scope") === "portfolio";
  return (
    <Layout>
      <div className="mb-8">
        <h1 className="font-display text-4xl font-extrabold tracking-tight flex items-center gap-3" data-testid="cards-page-title">
          <IdCard className="h-8 w-8 text-primary" /> Cards
          {portfolio && (
            <span className="text-xs font-bold uppercase tracking-wider px-2.5 py-1 rounded-full bg-violet-100 text-violet-700 border border-violet-300 inline-flex items-center gap-1.5" data-testid="cards-portfolio-badge">
              <Layers className="h-3.5 w-3.5" /> Portfolio view — all projects, all PMs
            </span>
          )}
          <SeeItInAction chapter={18} className="ml-1" />
        </h1>
        <p className="text-muted-foreground mt-2 max-w-2xl">
          {portfolio
            ? "Supervisor view: one card per person across every project in the portfolio, regardless of who manages it."
            : "One card per person across all your projects — open tasks, action items, and true-ups with dates and your notes. Email them on a cadence or send now."}
        </p>
      </div>
      <CardsView scope={portfolio ? "portfolio" : undefined} />
    </Layout>
  );
}
